// components/Modal/CrudModal.tsx
import React from "react";
import { Box, Button, Flex, Text } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import classes from "./CRUDModal.module.css";

// Định nghĩa các props mà bạn muốn truyền khi gọi hàm open
export interface CrudModalInnerProps {
  mode: "create" | "edit" | "view" | "delete";
  formId?: string;
  isLoading?: boolean;
  onConfirmDelete?: () => void;
  onClose?: () => void;
  children?: React.ReactNode;
  cancelText?: string;
  submitText?: string;
  deleteText?: string;
  hideFooter?: boolean;
}

// Component này sẽ được đăng ký vào ModalsProvider
const CRUDModal = ({
  context,
  id,
  innerProps,
}: ContextModalProps<CrudModalInnerProps>) => {
  const {
    mode,
    formId,
    isLoading,
    onConfirmDelete,
    children,
    cancelText = "Hủy",
    submitText = "Lưu",
    deleteText = "Xóa",
    hideFooter,
  } = innerProps;

  const handleClose = () => context.closeModal(id);

  const renderFooter = () => {
    if (mode === "view") {
      return (
        <Button variant="default" onClick={handleClose}>
          Đóng
        </Button>
      );
    }

    if (mode === "delete") {
      return (
        <Flex gap="xs" justify="flex-end">
          <Button variant="default" onClick={handleClose} disabled={isLoading}>
            {cancelText}
          </Button>
          <Button color="red" onClick={onConfirmDelete} loading={isLoading}>
            {deleteText}
          </Button>
        </Flex>
      );
    }

    return (
      <Flex gap="xs" justify="flex-end">
        <Button variant="default" onClick={handleClose} disabled={isLoading}>
          {cancelText}
        </Button>
        <Button type="submit" form={formId} loading={isLoading}>
          {submitText}
        </Button>
      </Flex>
    );
  };

  return (
    <Box mt={12}>
      <div className={classes.modalBody}>
        {mode === "delete" && !children ? (
          <Text color="red">Bạn có chắc chắn muốn xóa dữ liệu này?</Text>
        ) : (
          children
        )}
      </div>
      {!hideFooter && (
        <Box mt={12} className={classes.footer}>
          {renderFooter()}
        </Box>
      )}
    </Box>
  );
};

export default CRUDModal;
